import Decimal from 'decimal.js-light';
import { currencyNumberFormatter } from '../../../../../utils/format/currencyNumberFormatter';

/**
 * Centralizzazione di alcune logice relative alle voci di costo,
 * come il calcolo degli importi.
 */
export class PaymentRowLogic {
  /** Importo unitario (compreso di sconto) */
  static getUnitAmount(params: {
    baseUnitAmount: string | null | undefined;
    discount: number | null | undefined;
  }) {
    const { baseUnitAmount, discount } = params;

    if (baseUnitAmount == null || discount == null) return null;
    return new Decimal(baseUnitAmount).times(1 - discount / 100);
  }

  static getTaxableAmount(params: {
    unitAmount: Decimal | null | undefined;
    quantity: number | null | undefined;
  }) {
    const { unitAmount, quantity } = params;

    if (unitAmount == null || quantity == null) return null;

    return unitAmount.times(quantity);
  }

  static getVatAmount(params: {
    taxable: Decimal | null | undefined;
    vat: number | null | undefined;
  }) {
    const { taxable, vat } = params;

    if (taxable == null || vat == null) return null;
    return taxable.times(vat).div(100);
  }

  static getTotalAmount(params: {
    taxable: Decimal | null | undefined;
    vatAmount: Decimal | null | undefined;
  }) {
    const { taxable, vatAmount } = params;

    if (taxable == null || vatAmount == null) return null;
    return taxable.plus(vatAmount);
  }

  static formatCurrency(value: number | null) {
    return value != null ? currencyNumberFormatter.format(value) : '';
  }
}
